import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const Tooltip = ({ text, children, className, renderTooltip }) => {
  const shouldRender = (text && text.trim()) || children || renderTooltip;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={classnames('c-info-tooltip-new c-info-tooltip-new-handler u-ml--', className)}>
      <div display-if={!renderTooltip} className="c-info-tooltip-new__content">
        { text || children }
      </div>
      <div display-if={renderTooltip} className="c-info-tooltip-new__custom-content">
        {renderTooltip()}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  renderTooltip: PropTypes.func,
};
Tooltip.defaultProps = {
  text: '',
  children: null,
  className: '',
  renderTooltip: null,
};

export default Tooltip;
